import { useEffect } from "react";

export default function useAutoScroll(
    scrollIntoView: boolean,
    containerRef?: React.RefObject<HTMLElement | null>,
    selector: string = ".Mui-selected"
) {
    useEffect(() => {
        const scrollToSelected = () => {
            const selectedNode = (containerRef?.current ?? document).querySelector(selector);

            if (selectedNode) {
                selectedNode.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        };

        if (scrollIntoView) {
            setTimeout(() => {
                scrollToSelected();
            }, 100);
        }
    }, [
        scrollIntoView,
        containerRef,
        selector
    ]);
}

